import axios from "axios";
import Gantt, {
  Column,
  Dependencies,
  Editing,
  Item,
  ResourceAssignments,
  Resources,
  Tasks,
  Toolbar,
  Validation
} from "devextreme-react/gantt";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import swal from "sweetalert";
import { v4 as uuidv4 } from "uuid";
import { API_ROUTE, calcularDuracionV2, headersRequest } from "../../helpers";
import InputCalcGantt from "../InputCalcGantt";
import InputCalcRealHour from "../InputCalcRealHour";
import "./ganttSchedule.css";
import { ProgressBar } from "react-bootstrap";

require("devexpress-gantt/dist/dx-gantt.min.css");

const GanttSchedule = (props) => {

  const [tasks, setTasks] = useState([]);
  const [dependencies, setDependencies] = useState([]);
  const [resourceAssignments, setResourceAssignments] = useState([]);
  const selectedTask = useRef(null);
  const excludedDates = useRef([]);
  const companyResources = useRef([]);
  const [viewSubTask, setViewSubTask] = useState(true);

  const myGantt = useRef();

  const getGanttData = () => {
    let getTasks = new Promise((resolve, rej) => {
      axios
        .get(`${API_ROUTE}schedule-tasks-new/${props.uid}`, headersRequest())
        .then((res) => {
          let processed = res.data.map((task) => {
            return {
              ...task,
              start: new Date(task.start),
              end: new Date(task.end),
              parentId: !task.parentId ? 0 : task.parentId,
              cost: task.cost ? task.cost : 0,
              Hito: task.Hito,
            };
          });
          //   setTasks(processed);
          resolve(processed);
        });
    });
    let getDependencies = new Promise((resolve, rej) => {
      axios
        .get(
          `${API_ROUTE}schedule-tasks-dependencies/${props.uid}`,
          headersRequest()
        )
        .then((res) => {
          //   setDependencies(res.data);
          resolve(res.data);
        });
    });
    let getAssignments = new Promise((resolve, rej) => {
      axios
        .get(
          `${API_ROUTE}schedule-tasks-resources-assignments/${props.uid}`,
          headersRequest()
        )
        .then((res) => {
          //   setResourceAssignments(res.data);
          resolve(res.data);
        });
    });
    let getExcludedDates = new Promise((resolve, rej) => {
      axios.get(`${API_ROUTE}excluded-dates`, headersRequest()).then((res) => {
        // excludedDates.current = res.data;
        resolve(res.data);
      });
    });
    let getResources = new Promise((resolve, rej) => {
      axios
        .get(`${API_ROUTE}company-resources`, headersRequest())
        .then((res) => {
          //   companyResources.current = res.data;
          resolve(res.data);
        });
    });
    Promise.all([
      getTasks,
      getDependencies,
      getAssignments,
      getExcludedDates,
      getResources
    ]).then((values) => {
      excludedDates.current = values[3];
      companyResources.current = values[4];
      ReactDOM.unstable_batchedUpdates(() => {
        setTasks(values[0]);
        setDependencies(values[1]);
        setResourceAssignments(values[2]);
      });
    });
  };
  const addTask = (task) => {
    task.values.projectUID = props.uid;
    task.values.key = task.key;

    let startDate = (new Date(task.values.start)).getTime()
    let endDate = (new Date(task.values.end)).getTime()

    if( startDate === endDate) { 
        task.values.duration = 0
    }else if( startDate !== endDate) {
      task.values.duration = calcularDuracionV2(
        task.values.start,
        task.values.end,
        excludedDates.current
      );
    }
/* 
    task.values.duration = calcularDuracionV2(
      task.values.start,
      task.values.end,
      excludedDates.current
    ); */
    axios
      .post(`${API_ROUTE}schedule-tasks-new`, task.values, headersRequest())
      .then(() => {
        // console.log(tasks);
        // updateTasksIndex(tasks);
      })
      .catch((err) => {
        alert("error al crear la actividad, por favor refresca la página");
      });
  };
  const deleteTask = (task) => {
    axios
      .delete(`${API_ROUTE}schedule-tasks/${task.key}`, headersRequest())
      .catch((err) => {
        alert("error al eliminar la actividad, por favor refresca la página");
      });
  };
  const updateTask = (task) => {
    
    let taskUpdates = tasks.filter((item) => item.id === task.key)[0];
    
    if (taskUpdates.start > taskUpdates.end) {
      return;
    }
    taskUpdates.duration = calcularDuracionV2(
      taskUpdates.start,
      taskUpdates.end,
      excludedDates.current
    );
    
    taskUpdates.projectId = props.uid;

    if (task.values.start || task.values.end)
      taskUpdates.effort = taskUpdates.duration * 8;
    const manualValue = task.values.actualEffort
    const progressValue = Math.round((taskUpdates.effort * (taskUpdates.progress / 100)))
    
    taskUpdates.actualEffort = (task.values.progress && task.values.actualEffort) ? manualValue : progressValue
    taskUpdates.effort = (task.values.effort) ? task.values.effort : taskUpdates.effort
    taskUpdates.cost = (task.values.cost) ? task.values.cost : taskUpdates.cost
    taskUpdates.actualCost = (task.values.actualCost) ? task.values.actualCost : taskUpdates.actualCost
    axios
      .put(
        `${API_ROUTE}schedule-tasks-new/${task.key}`,
        taskUpdates,
        headersRequest()
      )
      .then(()=> {
        props.updatePctProje()
      })
      .catch((err) => {
        alert("error al actualizar la actividad, por favor refresca la página");
      });
  };
  const addDependecy = (dependency) => {
    // dependency.values.projectUID = props.uid;
    axios
      .post(
        `${API_ROUTE}schedule-tasks-dependencies/${props.uid}`,
        dependency.values,
        headersRequest()
      )
      .catch((err) => {
        alert("error al crear la relación, por favor refresca la página");
      });
  };
  const deleteDependecy = (task) => {
    
    axios
      .delete(
        `${API_ROUTE}schedule-tasks-dependencies/${task.values.predecessorId}/${task.values.successorId}/${props.uid}`,
        headersRequest()
      )
      .catch((err) => {
        alert("error al eliminar la relación, por favor refresca la página");
      });
  };
  const customCommand = (command) => {
    if (command.name === "addAbove" || command.name === "addBelow") {
      if (selectedTask.current) {
        let dummie = [...tasks];
        let pos = tasks.findIndex(
          (task) => task.id === selectedTask.current.id
        );

        if (command.name === "addBelow") {
          pos++;
        }

        let task = {
          id: uuidv4(),
          title:
            command.name === "addBelow"
              ? "Nueva Tarea Abajo"
              : "Nueva Tarea Arriba",
          parentId: selectedTask.current.parentId || 0,
          start: new Date(selectedTask.current.start),
          end: new Date(selectedTask.current.end)
        };

        let taskToSave = {
          ...task,
          projectUID: props.uid,
          key: task.id
        };

        axios
          .post(`${API_ROUTE}schedule-tasks-new`, taskToSave, headersRequest())
          .then(() => {
            dummie.splice(pos, 0, task);
            updateTasksIndex(dummie);
            setTasks([...dummie]);
          })
          .catch((err) => {
            alert("error al crear la actividad, por favor refresca la página");
          });
      } else { 
        swal("Seleccione una actividad","","info")
       /*  alert("Selecciona una actividad"); */
      }
    }else if(command.name === "hito") {
      if (selectedTask.current) {
        let dummie = [...tasks];
        let pos = tasks.findIndex(
          (task) => task.id === selectedTask.current.id
        );
        if (command.name === "hito") {
          pos++;
        }

        let task = {
          id: uuidv4(),
          title:
            command.name === "hito"? "Hito" :"",
          parentId: selectedTask.current.parentId || 0,
          start: new Date(selectedTask.current.end),
          end: new Date(selectedTask.current.end),
          Hito : command.hito,
        };

        let taskToSave = {
          ...task,
          projectUID: props.uid,
          key: task.id
        };

        axios
          .post(`${API_ROUTE}schedule-tasks-new`, taskToSave, headersRequest())
         
          .then(() => {
            dummie.splice(pos, 0, task);
            updateTasksIndex(dummie);
            setTasks([...dummie]);
          })
          .catch((err) => {
            alert("error al crear la actividad, por favor refresca la página");
          });
      } else {
        swal("Cree o seleccione una tarea previamente","","info")
        /* alert("Selecciona una actividad"); */
      }
    }else {
      return
    }
  } ;
  const updateTasksIndex = (tasks) => {
    axios
      .put(
        `${API_ROUTE}schedule-tasks-index/${props.uid}`,
        tasks,
        headersRequest()
      )
  };
  const addResource = (resource) => {
    
    axios
      .post(
        `${API_ROUTE}schedule-tasks-resources-assignments/${props.uid}`,
        resource.values,
        headersRequest()
      )
      .catch((err) => {
        alert("error al asignar el recurso, por favor refresca la página");
      });
  };
  const deleteResource = (resource) => {
    axios
      .delete(
        `${API_ROUTE}schedule-tasks-resources-assignments/${props.uid}/${resource.values.resourceId}/${resource.values.taskId}`,
        headersRequest()
      )
      .catch((err) => {
        alert("error al eliminar el recurso, por favor refresca la página");
      });
  };

  useEffect(() => {
    getGanttData();
  }, []);

  const [add] = useState(
    {
     text: 'Nueva Tarea',
     icon:'dx-gantt-i dx-gantt-i-add',
     stylingMode : 'text' 
    })

  const [subTask] = useState(
      {
       text: 'Nueva Sub-Tarea',
       icon:'dx-gantt-i dx-gantt-i-add-sub-task',
       stylingMode : 'text'
      }) 

  const [deleteTas] = useState(
      {
        text: 'Eliminar Tarea',
        icon:'dx-gantt-i dx-gantt-i-delete',
        stylingMode : 'text' 
      }) 

  const [addHito] = useState({ text: 'Añadir Hito', icon :'dx-gantt-task dx-gantt-milestone' })
  return (
    <>
      <Gantt
        className="overflow-auto"
        ref={myGantt}
        taskListWidth={800}
        scaleType="months"
        height={500}
        onTaskInserting={(task) => {
          if (tasks.length === 0 && task.values.title !== 'Hito') {
            task.values.start = moment(new Date())
              .hour(0)
              .minute(0)
              .second(0)._d;
            task.values.end = moment(new Date())
              .hour(0)
              .minute(0)
              .second(0)
              .add(20, "days")._d;
          }else if(tasks.length === 0 && task.values.title === "Hito"){
            task.values.start = moment(new Date())
            .hour(0)
            .minute(0)
            .second(0)._d;
          task.values.end = moment(new Date())
            .hour(0)
            .minute(0)
            .second(0)._d;
          }
          task.values.title = "Nueva Tarea " + (tasks.length + 1);
          task.values.progress = 0;
        }}
        onTaskInserted={addTask}
        onTaskUpdated={updateTask}
        onTaskDeleting={deleteTask}
        onDependencyInserted={addDependecy}
        onDependencyDeleted={deleteDependecy}
        validation={{ validateDependencies: true, autoUpdateParentTasks: true }}
        onTaskClick={(task) => {
          const getHito = tasks.filter( ta => ta.id === task.data.id)
          if(getHito[0].Hito){
            setViewSubTask(false)
          }else if( getHito[0].Hito === null) {
            setViewSubTask(true)
          }
          selectedTask.current = task.data
        }}
        onCustomCommand={customCommand}
        firstDayOfWeek={1}
        onResourceAssigned={addResource}
        onResourceUnassigned={deleteResource}
      >
        <Tasks dataSource={tasks} />
        <Dependencies dataSource={dependencies} />
        <Resources dataSource={companyResources.current} />
        <ResourceAssignments dataSource={resourceAssignments} />

        <Toolbar>
          <Item name="collapseAll" />
          <Item name="expandAll" />
          <Item name="separator" />
         {/*  <Item name="addTask" /> */}
          <Item options={add} name="addTask"/>
          {/* <Item name="addSubTask" /> */}
          <Item options={subTask} name="addSubTask" cssClass={(viewSubTask)? "": "dx-state-disabled"} />
          {/* <Item name="deleteTask" /> */}
          <Item options={deleteTas} name="deleteTask"/>
          <Item name="separator" />
          <Item name="zoomIn" />
          <Item name="zoomOut" />
          {/* <Item name="separator" /> */}
          <Item
            name="Añadir Arriba"
            onClick={() => {
              let command = { name: "addAbove" };
              customCommand(command);
            }}
          />
          <Item
            name="Añadir Abajo"
            onClick={() => {
              let command = { name: "addBelow" };
              customCommand(command);
            }}
          />
          <Item
          name="Añadir Hito"
          onClick={() => {
            let command = { name: "hito" , hito: true, };
            customCommand(command);
          }}
          options={addHito}
        />
        </Toolbar>

        {/* <ContextMenu>
          <Item text="Añadir">
            <Item name="addTask" text="Tarea" />
            <Item name="addSubTask" text="Tarea anidada" />
            <Item name="addAbove" text="Tarea arriba" />
            <Item name="addBelow" text="Tarea abajo" />
          </Item>
          <Item name="taskDetails" text="Ver detalles" />
          <Item name="deleteTask" text="Eliminar tarea" />
        </ContextMenu> */}

        <Column dataField="title" caption="Actividad" width={200} />
        <Column dataField="start" caption="Inicio" width={80} />
        <Column dataField="end" caption="Fin" width={80} />
        <Column
          dataField="duration"
          caption="Duración"
          cellRender={(row) => {
            let startDate = (new Date(row.data.start)).getTime()
            let endDate = (new Date(row.data.end)).getTime()       
            return ( 
              <>
              { ( startDate === endDate) && 
              <span className="text-right d-block w-100">0 días</span> 
              } 
              {(startDate !== endDate) && 
                <span className="text-right d-block w-100">
                {calcularDuracionV2(
                  row.data.start,
                  row.data.end,
                  excludedDates.current
                )}{" "}
                días
              </span>
              } 
             </>)
          }}
        />
        <Column
          dataField="effort"
          caption="Horas"
          cellRender={(row) => {
            return (
              <InputCalcGantt
                task={row.data}
                updateTask={updateTask}
                myGantt={myGantt}
                tasks={tasks}
                name="effort"
                placeholder="0 Hrs."
              />
            );
          }}
        />
        <Column
          dataField="actualEffort"
          caption="Horas Reales"
          cellRender={(row) => {
            return (
              <InputCalcRealHour
              task={row.data}
              myGantt={myGantt}
              tasks={tasks}
              updateTask={updateTask}
              name="actualEffort"
              placeholder="0 Hrs."
              />
            );
          }}
        />
        <Column
          dataField="cost"
          caption="Costo"
          cellRender={(row) => {
            return (
              <InputCalcGantt
                task={row.data}
                myGantt={myGantt}
                updateTask={updateTask}
                tasks={tasks}
                name="cost"
                placeholder="$0"
              />
            );
          }}
        />
        <Column
          dataField="actualCost"
          caption="Costo Real"
          cellRender={(row) => {
            return (
              <InputCalcGantt
                task={row.data}
                updateTask={updateTask}
                myGantt={myGantt}
                tasks={tasks}
                name="actualCost"
                placeholder="$0"
              />
            );
          }}
        />
        <Column
       /*  dataField={} */
       caption= "Progreso"
       cellRender={(row)=>{
          return (
                <span className="d-flex align-items-center justify-content-end">
                  <ProgressBar
                    variant="success"
                    now = {row.data.progress}
                    style={{ height: "10px", width: "calc(100%)" }}
                    className="mr-2"
                  />
                  <span>{row.data.progress}%
                  </span>
                </span>
          )
        }}
        />
        <Validation autoUpdateParentTasks={true} />
        <Editing enabled={true} />
      </Gantt>
    </>
  );
};

export default React.memo(GanttSchedule);
